import { Pipe, PipeTransform, Inject } from '@angular/core';

@Pipe({
  name: 'capitalizeFirst'
})
export class CapitalizeFirstPipe implements PipeTransform {
  transform(value: string) : string {
    return value.substr(0, 1).toUpperCase() + value.substr(1);
  }
}


// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/pipes/capitalize-first.pipe.ts